import { urlApi } from "../../utils/strings"
import { HistorialDescargablesI } from "../../models/descargables"

export const getHistorialDescargable = async (id_descargable: string) => {

  const response = await fetch(urlApi(`/descargables/obtenerHistorialDescargables.php?id_descargable=${id_descargable}`)); 
       
  const historialDescargables = await response.json(); 
  
  return historialDescargables.historial as HistorialDescargablesI

}

export const getHistorialDescargableAll = async () => {

  const response = await fetch(urlApi(`/descargables/obtenerHistorialDescargables.php`)); 
       
  const historialDescargables = await response.json(); 
  
  return historialDescargables.historial as HistorialDescargablesI

}


